__turbopack_context__.v({
  "buttonContainer": "News-module__GTQH-G__buttonContainer",
  "card": "News-module__GTQH-G__card",
  "heading": "News-module__GTQH-G__heading",
  "publicFace": "News-module__GTQH-G__publicFace",
  "textContent": "News-module__GTQH-G__textContent",
  "turnPageButton": "News-module__GTQH-G__turnPageButton",
});
